import { useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import DataTableMessages from "../intl/DataTableMessages";

const RESET_TIMEOUT = 400;
const { copyToClipboard, copied } = DataTableMessages;

interface UseClickHandlerProps {
  copiedMsg: string;
  copyToMsg: string;
  fieldValue: string;
  setTtipMsg: (msg: string) => void;
}

export const useClickHandler = ({
  copiedMsg,
  copyToMsg,
  fieldValue,
  setTtipMsg,
}: UseClickHandlerProps) => {
  const updateTtip = useCallback(() => {
    setTtipMsg(copiedMsg);
    setTimeout(() => setTtipMsg(copyToMsg), RESET_TIMEOUT);
  }, [copiedMsg, copyToMsg, setTtipMsg]);

  return useCallback(() => {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(fieldValue)
        .then(updateTtip)
        .catch(() => {});
    }
  }, [fieldValue, updateTtip]);
};

export const useMsgs = () => {
  const { formatMessage } = useIntl();
  return useMemo(
    () => ({
      copyToMsg: formatMessage(copyToClipboard),
      copiedMsg: formatMessage(copied),
    }),
    [formatMessage]
  );
};
